import React, { useCallback, useEffect, useLayoutEffect, useMemo } from 'react';
import { noop } from 'lodash';
import { getCategories } from 'actions';
import Indicator from 'design-system/Indicator';
import { AppView } from 'design-system/AppView';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import { IconCategory } from 'design-system/icons/IconCategory';
import useColors from 'hooks/useColors';
import { isIOS, isWeb } from '../../../constants';
import EditCategoryList from '../components/categories/EditCategoryList';
const PickCategoryScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation, route }) => {
    const { onPickCategory, category, hideExcluded, hideSubcategories, hideNone, title, subtitle, hiddenCategories, firstItem, } = route.params;
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            ...(isIOS && {
                headerLeft: () => (<NavigationCloseButton onPress={() => navigation.pop()}/>),
            }),
        });
    }, []);
    const isFetching = useAppSelector((store) => store.user.isFetching && !store.user.categories?.length);
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getCategories());
    }, []);
    const handlePickCategory = useCallback((data) => {
        onPickCategory('customContent' in data ? undefined : data, false);
    }, [onPickCategory]);
    const noneFirstItem = useMemo(() => ({
        id: 'none',
        displayName: 'None',
        customContent: (<IconCategory alt color={colors.categories.custom} width={32} height={32}/>),
    }), [colors.categories.custom]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb, true);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    if (isFetching) {
        return <Indicator dark/>;
    }
    return (<AppView withFrame={false}>
          <EditCategoryList title={title} subTitle={subtitle} scrollHandler={scrollHandler} selectedCategory={category} contentContainerStyle={contentContainerStyle} onPressCategory={handlePickCategory} onLongPressCategory={noop} firstItem={hideNone ? undefined : firstItem ?? noneFirstItem} hideExcluded={hideExcluded} hideSubcategories={hideSubcategories} hiddenCategories={hiddenCategories} isInIOS13Modal/>
        </AppView>);
}, ({ colors }) => ({
    title: '',
    pageTitle: 'Pick a category',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    isIOS13NativeModal: true,
}));
export default PickCategoryScreen;
